import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type GroupChatAddMemberDialogStateType = {
  searchKeyword: string
}

const initialGroupChatAddMemberDialogState: GroupChatAddMemberDialogStateType =
  {
    searchKeyword: '',
  }

export const groupChatAddMemberDialogSlice = createSlice({
  name: 'groupChatAddMemberDialog',
  initialState: initialGroupChatAddMemberDialogState,
  reducers: {
    setSearchKeyword: (state, action: PayloadAction<string>) => {
      state.searchKeyword = action.payload
    },
  },
})

export const { setSearchKeyword } = groupChatAddMemberDialogSlice.actions
